import React, { useEffect, createElement } from 'react';
import { useScreenInit } from './useScreenInit';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { SalesLetter } from './components/SalesLetter';
import { WhatYouGet } from './components/WhatYouGet';
import { SocialProof } from './components/SocialProof';
import { IncludesStack } from './components/IncludesStack';
import { BonusSection } from './components/BonusSection';
import { PricingOffer } from './components/PricingOffer';
import { Guarantee } from './components/Guarantee';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  useScreenInit();
  // Official Meta Pixel — init + PageView on load.
  useEffect(() => {
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', '1724342565264992');
    }
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-full w-full bg-cream font-sans text-ink" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <main data-id="element-2">
        {/* B. Hero (the hook) */}
        <HeroSection data-id="element-3" />

        {/* C. Sales letter — pains (red) + solutions (green) */}
        <SalesLetter data-id="element-4" />

        {/* D. What you get — alternating feature stack */}
        <WhatYouGet data-id="element-5" />

        {/* G. Social proof — masonry testimonials */}
        <SocialProof data-id="element-6" />

        {/* Includes recap */}
        <IncludesStack data-id="element-7" />

        {/* E. Bonus value stack */}
        <BonusSection data-id="element-8" />

        {/* F. Dynamic pricing offer */}
        <PricingOffer data-id="element-9" />

        {/* Guarantee */}
        <Guarantee data-id="element-10" />

        {/* FAQ */}
        <FaqSection data-id="element-11" />

        {/* Final CTA + scarcity + P.D. */}
        <FinalCta data-id="element-12" />
      </main>

      {/* Footer */}
      <SiteFooter data-id="element-13" />
    </div>;
}